import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'src/app/shared/models/subscription';
import { UserDetail } from 'src/app/shared/models/user-detail';
import { DataService } from 'src/app/shared/services/data-service/data.service';
import { StoreService } from 'src/app/shared/services/store-service/store.service';
import { UserService } from 'src/app/shared/services/user-service/user.service';

@Component({
  standalone: false,
  selector: 'app-subscription-form',
  templateUrl: './subscription-form.component.html',
  styleUrls: ['./subscription-form.component.scss'],
})
export class SubscriptionFormComponent implements OnInit {
  loading: boolean;
  subscribeApoToIdp: boolean;
  subscribePlanIngest: boolean;
  user: UserDetail = new UserDetail();
  userSubscriptions: Subscription[];
  eventSubscriptions: {
    [key: string]: { label: string; subscribed: boolean };
  } = {
    APODemandDataPublishedToIDP: {
      label: 'Plan publishing to IDP',
      subscribed: false,
    },
    DemandDataIngestedBySupplier: {
      label: 'Plan ingestion by supplier',
      subscribed: false,
    },
  };

  constructor(
    public storeService: StoreService,
    private userService: UserService,
    private dataService: DataService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.loading = true;
  }

  get events() {
    return Object.keys(this.eventSubscriptions);
  }

  async ngOnInit(): Promise<void> {
    // Get email of the user
    this.user = await this.userService.getUserDetail();

    // Get subscription
    this.userSubscriptions = await this.dataService.getSubscriptionByEmail(
      this.user.email
    );

    // Assign value to scoped events
    this.userSubscriptions.map(({ eventName, subscribed }) => {
      this.eventSubscriptions[eventName].subscribed = subscribed;
    });

    this.loading = false;
  }

  async onSubmit() {
    try {
      await Promise.all(
        Object.keys(this.eventSubscriptions).map(async (event) => {
          const subscription = this.userSubscriptions.find(
            (subscription) => subscription.eventName === event
          );

          if (subscription) {
            // update to this.userSubscriptions
            const index = this.userSubscriptions.indexOf(subscription);
            this.userSubscriptions[index] = {
              ...subscription,
              subscribed: this.eventSubscriptions[event].subscribed,
              lastChangedBy: this.user.name,
            };
            this.userSubscriptions = [...this.userSubscriptions];
            // update to db
            await this.dataService.updateSubscription({
              ...subscription,
              subscribed: this.eventSubscriptions[event].subscribed,
              lastChangedBy: this.user.name,
            });
          } else {
            const maxRowKey = Math.max(
              ...this.userSubscriptions.map((subscription) =>
                parseInt(subscription.rowKey)
              ),
              0
            );
            var newSubscription = {
              eventName: event,
              lastChangedBy: this.user.name,
              partitionKey: this.user.email,
              rowKey: (maxRowKey + 1).toString(),
              subscribed: this.eventSubscriptions[event].subscribed,
              timestamp: '', // Will be generated by the backend
            };

            // update local list
            this.userSubscriptions = [
              ...this.userSubscriptions,
              newSubscription,
            ];

            // update to DB
            await this.dataService.createSubscription(newSubscription);
          }
        })
      );

      this.toastr.success(
        'Your subscription has been updated',
        'Subscription for email notification'
      );
    } catch {
      this.toastr.error(
        'Error occurred when updating subscription',
        'Subscription for email notification'
      );
      // refresh data
      this.userSubscriptions = await this.dataService.refreshUserSubscriptions(
        this.user.email
      );
    }
  }

  cancelClick(): void {
    this.router.navigate(['/']);
  }
}

